module.exports = __webpack_public_path__ + "static/media/Icon ionic-md-information-circle.923c42d4.svg";